import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router";
import Home from "./pages/Home/Home";
import Transaction from "./pages/Transaction/Transaction";
import AppLayout from "./layout/AppLayout";

export default function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <AppLayout>
                <Home />
              </AppLayout>
            }
          />
          <Route
            path="/transaction"
            element={
              <AppLayout>
                <Transaction />
              </AppLayout>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </>
  );
}
